import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_SECTION',
  GET: 'GET_SECTION',
  CREATE: 'CREATE_SECTION',
  EDIT: 'EDIT_SECTION',
  DELETE: 'DELETE_SECTION',
  DUPLICATE: 'DUPLICATE_SECTION',
  ADD_SECTION_TO_ENVELOP: 'ADD_SECTION_TO_ENVELOP',
  REMOVE_SECTION_FROM_ENVELOP: 'REMOVE_SECTION_FROM_ENVELOP',
  EDIT_SECTION_IN_ENVELOP: 'EDIT_SECTION_IN_ENVELOP',
  CLEAR_ERROR: 'CLEAR_ERROR_SECTION',
};

export const searchSectionByText = (text, buildingId, page = 0) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  const envelopId = null;
  return searchSection(pageSize, page, sorted, filtered, isPublic, buildingId, envelopId);
};

export const searchSection = (pageSize, page, sorted, filtered, isPublic, buildingId, envelopId = undefined) => {
  let envelopParams = { building_id: buildingId };
  if (envelopId !== undefined) {
    envelopParams = {
      ...envelopParams,
      ...(envelopId === null ? {envelop_id__isnull: true} : {envelop_id: envelopId})
    };
  }

  return RestClient.request({
    method: 'get',
    url: Constants.API_SECTION,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...envelopParams,
    },
  });
};

export const listSection = (pageSize, page, sorted, filtered, isPublic, buildingId, envelopId) => {
  return {
    type: ACTION.LIST,
    payload: searchSection(pageSize, page, sorted, filtered, isPublic, buildingId, envelopId)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getSection = sectionId => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_SECTION}${sectionId}/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const createSection = (name, envelopId, description, buildingId, quantity = 1) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('envelop_id', envelopId == null ? '' : envelopId);
  formData.set('quantity', quantity);
  formData.set('description', description);
  formData.set('building_id', buildingId);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_SECTION,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editSection = (id, name, envelopId, description, quantity = 1) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (envelopId !== undefined) formData.set('envelop_id', envelopId == null ? '' : envelopId);
  if (quantity) formData.set('quantity', quantity);
  if (typeof description === 'string') formData.set('description', description);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_SECTION}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteSection = (sectionId, params) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_SECTION}${sectionId}/`,
      data: params,
    })
      .then(() => ({ id: sectionId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateSection = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_SECTION}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const addSectionToEnvelop = (id, quantity, envelopId) => {
  const formData = new FormData();
  formData.set('envelop_id', envelopId);
  formData.set('quantity', quantity);

  return {
    type: ACTION.ADD_SECTION_TO_ENVELOP,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_SECTION}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeSectionFromEnvelop = id => {
  const formData = new FormData();
  formData.set('envelop_id', '');

  return {
    type: ACTION.REMOVE_SECTION_FROM_ENVELOP,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_SECTION}${id}/`,
      data: formData,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const editSectionInEnvelop = (id, quantity) => {
  const formData = new FormData();
  formData.set('quantity', quantity);
  return {
    type: ACTION.EDIT_SECTION_IN_ENVELOP,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_SECTION}${id}/`,
      data: formData,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorSection = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/section/section_actions.js